
















import Vue from "vue";

export interface ModalData {
  currentScrollAmount: {
    x: number;
    y: number;
  };
}

export default Vue.extend({
  name: "vc-modal",
  data() {
    return {
      currentScrollAmount: {
        x: 0,
        y: 0,
      },
    };
  },
  mounted() {
    // モーダルを開いている時は背景がスクロールされないよう現在スクロール位置を保持する
    this.currentScrollAmount = {
      x: window.scrollX || window.pageXOffset,
      y: window.scrollY || window.pageYOffset,
    };
    document.body.classList.add("fixedPosition");
    document.body.style.top = (-this.currentScrollAmount.y).toString() + "px";
    document.body.style.left = (-this.currentScrollAmount.x).toString() + "px";
    // position:fixedとするとiOS15で下部に空白が生まれるため全体の高さを指定する
    document.documentElement.style.height = "100vh";
  },
  beforeDestroy() {
    // モーダルを閉じた時は表示処理をスクロール位置に戻す
    document.body.classList.remove("fixedPosition");
    window.scrollTo(this.currentScrollAmount.x, this.currentScrollAmount.y);
    document.documentElement.style.height = "";
  },
});
